var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCiCd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E24329;}\r\n\t.st1{fill:#FC6D26;}\r\n\t.st2{fill:#FCA326;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CI-CD_tech"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "65,70 65,70 75,39.3 55,39.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65,70 55,39.3 41,39.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41,39.3L41,39.3l-3,9.3c-0.3,0.8,0,1.8,0.8,2.3L65,70L41,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41,39.3h14l-6-18.5c-0.1-0.5-0.7-0.9-1.2-0.7c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.4-0.7,0.7L41,39.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65,70 75,39.3 89,39.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89,39.3L89,39.3l3,9.3c0.3,0.8,0,1.8-0.7,2.3L65,70L89,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89,39.3H75l6-18.5c0.2-0.6,0.7-0.9,1.3-0.7c0,0,0,0,0,0c0.3,0.1,0.6,0.4,0.7,0.7L89,39.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiCd);
export default __webpack_public_path__ + "static/media/CI-CD.e4dd1b3b0d289b3b3f8a1e236690a424.svg";
export { ForwardRef as ReactComponent };